var map = {
	"./1.jpg": 2184,
	"./10.jpg": 7086,
	"./2.jpg": 4911,
	"./3.jpg": 2135,
	"./4.jpg": 9803,
	"./5.jpg": 1812,
	"./6.jpg": 5141,
	"./7.jpg": 4516,
	"./8.jpg": 8341,
	"./9.jpg": 5737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7095;